export default __webpack_public_path__ + "static/media/11-TheBreak.1e07c836.jpeg";